@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details">
        <div
            class="screens"
            [attr.name]="'assetmanagement.detail.menuAsset' | transloco"
            menuicon="fas fa-cube"
            menusystemsubmenu
        >
            <div
                [attr.name]="'assetmanagement.detail.menuDetails' | transloco"
                menuItemId="details"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                @if (model) {
                    <app-cerrix-header
                        [title]="model.name"
                        [edit]="false"
                        [breadcrumbs]="breadcrumbs"
                    ></app-cerrix-header>
                    <div class="body">
                        <div class="tabs-container-block">
                            <div class="meta-data-detail-screen">
                                <div class="meta-data-content">
                                    <app-asset-owner-selector
                                        [users]="users"
                                        [ownerId]="model.ownershipInformation?.ownerId"
                                        (ownerIdChange)="onOwnerIdChange($event)"
                                        readonly="true"
                                    ></app-asset-owner-selector>
                                </div>
                                <div class="meta-data-content">
                                    <div class="meta-data-label">
                                        <span>{{
                                            "assetmanagement.detail.dateInUseLabel" | transloco
                                        }}</span>
                                    </div>
                                    <div class="meta-data-values">
                                        <span>{{
                                            model.lifecycle?.dateInUse | date: "dd-MM-yyyy"
                                        }}</span>
                                    </div>
                                </div>
                                <div class="meta-data-content">
                                    <div class="meta-data-label">
                                        <span>{{
                                            "assetmanagement.detail.dateOutOfUseLabel" | transloco
                                        }}</span>
                                    </div>
                                    <div class="meta-data-values">
                                        <span>{{
                                            model.lifecycle?.dateOutOfUse | date: "dd-MM-yyyy"
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <app-asset-tabs-header
                                [(selectedTab)]="selectedTab"
                            ></app-asset-tabs-header>
                            <div class="tabs-detail-block">
                                @switch (selectedTab) {
                                    @case ("overview") {}
                                    @case ("assessments") {}
                                    @case ("linkedItems") {}
                                    @case ("documentandhyperlinks") {
                                        <app-asset-document-hyperlink-toggle
                                            [model]="model"
                                            [canEdit]="canEdit"
                                            (hyperlinksChanged)="onHyperlinksChanged($event)"
                                        ></app-asset-document-hyperlink-toggle>
                                    }
                                    @case ("history") {}
                                }
                            </div>
                        </div>
                        <div class="details-block">
                            <div class="details-header">
                                {{ "assetmanagement.detail.detailsTitle" | transloco }}
                            </div>
                            <div class="details-content">
                                <div class="details-row full-width">
                                    <span class="details-title">{{
                                        "assetmanagement.detail.descriptionValueLabel" | transloco
                                    }}</span>
                                    <span class="details-value">{{ model.description }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "assetmanagement.detail.thirdPartyValueLabel" | transloco
                                    }}</span>
                                    <span class="details-value">{{ thirdPartyName }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "assetmanagement.detail.contractValueLabel" | transloco
                                    }}</span>
                                    <span class="details-value">{{ contractNumber }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "assetmanagement.detail.organizationOwnerValueLabel"
                                            | transloco
                                    }}</span>
                                    <span class="details-value">{{
                                        getOrgOwnerName(
                                            model.ownershipInformation.owningOrganizationId
                                        )
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <cerrix-page-footer>
                        <div class="asset-management-footer">
                            <div class="left-button-group">
                                @if (canEdit) {
                                    <cerrix-icon-button
                                        buttonType="secondary"
                                        buttonSize="big"
                                        secondaryColor="outlined-gray"
                                        data-uiid="asset-management-edit-asset"
                                        icon="edit"
                                        iconPosition="right"
                                        [text]="'assetmanagement.detail.editButton' | transloco"
                                        (click)="edit()"
                                    >
                                    </cerrix-icon-button>
                                }
                            </div>
                        </div>
                    </cerrix-page-footer>
                    @if (canEdit) {
                        <app-cerrix-slide-out-edit-item
                            [title]="'assetmanagement.detail.editTitle' | transloco"
                            [isOpen]="editActive"
                            (isOpenChange)="closeCancel()"
                            [(items)]="sections"
                        >
                            @if (editActive) {
                                @switch (sections.activeItem) {
                                    @case ("general") {
                                        <app-edit-asset-general-information
                                            [model]="model"
                                            (modelChange)="onModelChange($event)"
                                            (closeEdit)="closeCancel()"
                                        ></app-edit-asset-general-information>
                                    }
                                    @case ("lifecycle") {
                                        <app-edit-asset-lifecycle-information
                                            [model]="model"
                                            (modelChange)="model = $event"
                                            (closeEdit)="closeCancel()"
                                        ></app-edit-asset-lifecycle-information>
                                    }
                                    @case ("ownership") {
                                        <app-edit-asset-ownership-information
                                            [model]="model"
                                            (modelChange)="model = $event"
                                            (closeEdit)="closeCancel()"
                                        ></app-edit-asset-ownership-information>
                                    }
                                }
                            }
                        </app-cerrix-slide-out-edit-item>
                    }
                }
            </div>
        </div>
    </div>
}
